import { create } from 'zustand';

export const useCurrencyStore = create(() => ({
  currency: 'LKR',
  currencySymbol: 'Rs.',
}));

export const setCurrency = (c) => useCurrencyStore.setState({ currency: c || 'LKR' });

export const getCurrencySymbol = () => useCurrencyStore.getState().currencySymbol;